import React from 'react';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Card from '@mui/material/Card';
import {Link} from 'react-router-dom';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { Button, Box, CardActionArea, CardActions} from '@mui/material';
import { useRef } from 'react';


import projectthreecard from "../images/Portfolioprojectthreecard.jpg"
import projectonecard from "../images/Portfolioprojectonecard.jpg"
import projecttwocard from "../images/Portfolioprojecttwocard.jpg"
import comingsoonprojectcard from "../images/comingsoon.png"

import { blue } from '@mui/material/colors';
import './pagesStyles.css';
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import { useCallback } from "react";




const Projects = () => {

    const options = {
        autoPlay: true,
        background: {
          color: {
            value: "#000000"
          },
          image: "",
          position: "",
          repeat: "",
          size: "",
          opacity: 1        },
        backgroundMask: {
          composite: "destination-out",
          cover: {
            color: {
              value: "#fff"
            },
            opacity: 1
          },
          enable: false
        },
        defaultThemes: {},
        delay: 0,
        fullScreen: {
          enable: true,
          zIndex: -1
        },
        detectRetina: true,
        duration: 0,
        fpsLimit: 120,
        interactivity: {
          detectsOn: "window",
          events: {
            onClick: {
              enable: false,
              mode: []
            },
            onDiv: {
              selectors: [],
              enable: false,
              mode: [],
              type: "circle"
            },
            onHover: {
              enable: true,
              mode: "trail",
              parallax: {
                enable: false,
                force: 2,
                smooth: 10
              }
            },
            resize: {
              delay: 0.5,
              enable: true
            }
          },
          modes: {
            attract: {
              distance: 200,
              duration: 0.4,
              easing: "ease-out-quad",
              factor: 1,
              maxSpeed: 50,
              speed: 1
            },
            bounce: {
              distance: 200
            },
            bubble: {
              distance: 200,
              duration: 0.4,
              mix: false,
              divs: {
                distance: 200,
                duration: 0.4,
                mix: false,
                selectors: []
              }
            },
            connect: {
              distance: 80,
              links: {
                opacity: 0.5
              },
              radius: 60
            },
            grab: {
              distance: 100,
              links: {
                blink: false,
                consent: false,
                opacity: 1
              }
            },
            push: {
              default: true,
              groups: [],
              quantity: 4
            },
            remove: {
              quantity: 2
            },
            repulse: {
              distance: 200,
              duration: 0.4,
              factor: 100,
              speed: 1,
              maxSpeed: 50,
              easing: "ease-out-quad",
              divs: {
                distance: 200,
                duration: 0.4,
                factor: 100,
                speed: 1,
                maxSpeed: 50,
                easing: "ease-out-quad",
                selectors: []
              }
            },
            slow: {
              factor: 3,
              radius: 200
            },
            trail: {
              delay: 0.005,
              pauseOnStop: true,
              quantity: 5,
              particles: {
                color: {
                  value: "#ff0000",
                  animation: {
                    enable: true,
                    speed: 400,
                    sync: true
                  }
                },
                collisions: {
                  enable: false
                },
                links: {
                  enable: false
                },
                move: {
                  outModes: {
                    default: "destroy"
                  },
                  speed: 2
                },
                size: {
                  value: 5,
                  animation: {
                    enable: true,
                    speed: 5,
                    minimumValue: 1,
                    sync: true,
                    startValue: "min",
                    destroy: "max"
                  }
                }
              }
            },
            light: {
              area: {
                gradient: {
                  start: {
                    value: "#ffffff"
                  },
                  stop: {
                    value: "#000000"
                  }
                },
                radius: 1000
              },
              shadow: {
                color: {
                  value: "#000000"
                },
                length: 2000
              }
            }
          }
        },
        manualParticles: [],
        particles: {
          bounce: {
            horizontal: {
              random: {
                enable: false,
                minimumValue: 0.1
              },
              value: 1
            },
            vertical: {
              random: {
                enable: false,
                minimumValue: 0.1
              },
              value: 1
            }
          },
          collisions: {
            absorb: {
              speed: 2
            },
            bounce: {
              horizontal: {
                random: {
                  enable: false,
                  minimumValue: 0.1
                },
                value: 1
              },
              vertical: {
                random: {
                  enable: false,
                  minimumValue: 0.1
                },
                value: 1
              }
            },
            enable: true,
            mode: "bounce",
            overlap: {
              enable: true,
              retries: 0
            }
          },
          color: {
            value: "#ff0000",
            animation: {
              h: {
                count: 0,
                enable: true,
                offset: 0,
                speed: 50,
                decay: 0,
                sync: false
              },
              s: {
                count: 0,
                enable: false,
                offset: 0,
                speed: 1,
                decay: 0,
                sync: true
              },
              l: {
                count: 0,
                enable: false,
                offset: 0,
                speed: 1,
                decay: 0,
                sync: true
              }
            }
          },
          groups: {
            z5000: {
              number: {
                value: 70
              },
              zIndex: {
                value: 50
              }
            },
            z7500: {
              number: {
                value: 30
              },
              zIndex: {
                value: 75
              }
            },
            z2500: {
              number: {
                value: 50
              },
              zIndex: {
                value: 25
              }
            },
            z1000: {
              number: {
                value: 40
              },
              zIndex: {
                value: 10
              }
            }
          },
          move: {
            angle: {
              offset: 0,
              value: 90
            },
            attract: {
              distance: 200,
              enable: false,
              rotate: {
                x: 3000,
                y: 3000
              }
            },
            center: {
              x: 50,
              y: 50,
              mode: "percent",
              radius: 0
            },
            decay: 0,
            distance: {},
            direction: "none",
            drift: 0,
            enable: true,
            gravity: {
              acceleration: 9.81,
              enable: false,
              inverse: false,
              maxSpeed: 50
            },
            path: {
              clamp: true,
              delay: {
                random: {
                  enable: false,
                  minimumValue: 0
                },
                value: 0
              },
              enable: false,
              options: {}
            },
            outModes: {
              default: "out",
              bottom: "out",
              left: "out",
              right: "out",
              top: "out"
            },
            random: false,
            size: false,
            speed: 2,
            spin: {
              acceleration: 0,
              enable: false
            },
            straight: false,
            trail: {
              enable: false,
              length: 10,
              fillColor: {
                value: "#000000"
              }
            },
            vibrate: false,
            warp: false
          },
          number: {
            density: {
              enable: true,
              width: 1920,
              height: 1080
            },
            limit: 0,
            value: 100
          },
          opacity: {
            random: {
              enable: true,
              minimumValue: 0.3
            },
            value: {
              min: 0.3,
              max: 0.8
            },
            animation: {
              count: 0,
              enable: true,
              speed: 0.5,
              decay: 0,
              sync: false,
              destroy: "none",
              startValue: "random",
              minimumValue: 0.3
            }
          },
          reduceDuplicates: false,
          shadow: {
            blur: 0,
            color: {
              value: "#000"
            },
            enable: false,
            offset: {
              x: 0,
              y: 0
            }
          },
          shape: {
            options: {},
            type: "circle"
          },
          size: {
            random: {
              enable: true,
              minimumValue: 1
            },
            value: {
              min: 1,
              max: 3
            },
            animation: {
              count: 0,
              enable: true,
              speed: 3,
              decay: 0,
              sync: false,
              destroy: "none",
              startValue: "random",
              minimumValue: 1
            }
          },
          stroke: {
            width: 0
          },
          zIndex: {
            random: {
              enable: false,
              minimumValue: 0
            },
            value: 0,
            opacityRate: 1,
            sizeRate: 1,
            velocityRate: 1
          },
          life: {
            count: 0,
            delay: {
              random: {
                enable: false,
                minimumValue: 0
              },
              value: 0,
              sync: false
            },
            duration: {
              random: {
                enable: false,
                minimumValue: 0.0001
              },
              value: 0,
              sync: false
            }
          },
          rotate: {
            random: {
              enable: false,
              minimumValue: 0
            },
            value: 0,
            animation: {
              enable: false,
              speed: 0,
              decay: 0,
              sync: false
            },
            direction: "clockwise",
            path: false
          },
          destroy: {
            bounds: {},
            mode: "none",
            split: {
              count: 1,
              factor: {
                random: {
                  enable: false,
                  minimumValue: 0
                },
                value: 3
              },
              rate: {
                random: {
                  enable: false,
                  minimumValue: 0
                },
                value: {
                  min: 4,
                  max: 9
                }
              },
              sizeOffset: true,
              particles: {}
            }
          },
          roll: {
            darken: {
              enable: false,
              value: 0
            },
            enable: false,
            enlighten: {
              enable: false,
              value: 0
            },
            mode: "vertical",
            speed: 25
          },
          tilt: {
            random: {
              enable: false,
              minimumValue: 0
            },
            value: 0,
            animation: {
              enable: false,
              speed: 0,
              decay: 0,
              sync: false
            },
            direction: "clockwise",
            enable: false
          },
          twinkle: {
            lines: {
              enable: false,
              frequency: 0.05,
              opacity: 1
            },
            particles: {
              enable: false,
              frequency: 0.05,
              opacity: 1
            }
          },
          wobble: {
            distance: 5,
            enable: false,
            speed: {
              angle: 50,
              move: 10
            }
          },
          orbit: {
            animation: {
              count: 0,
              enable: false,
              speed: 1,
              decay: 0,
              sync: false
            },
            enable: false,
            opacity: 1,
            rotation: {
              random: {
                enable: false,
                minimumValue: 0
              },
              value: 45
            },
            width: 1
          },
          links: {
            blink: false,
            color: {
              value: "random"
            },
            consent: false,
            distance: 100,
            enable: true,
            frequency: 1,
            opacity: 0.4,
            shadow: {
              blur: 5,
              color: {
                value: "#000"
              },
              enable: false
            },
            triangles: {
              enable: false,
              frequency: 1
            },
            width: 1,
            warp: false
          },
          repulse: {
            random: {
              enable: false,
              minimumValue: 0
            },
            value: 0,
            enabled: false,
            distance: 1,
            duration: 1,
            factor: 1,
            speed: 1
          }
        },
        pauseOnBlur: true,
        pauseOnOutsideViewport: true,
        responsive: [],
        smooth: false,
        style: {},
        themes: [],
        zLayers: 100,
        emitters: []
      }
    ;
    
   
    const particlesInit = useCallback(async (engine) => {
      await loadFull(engine);
    }, []);

    return (
        
        <div
        style={{
            height : "100vh",
            width: "100vw",
            justifyContent: 'space-between'
            
    

           
            

        }}
        >
        <Particles options={options} init={particlesInit} />

        
        <Card className="card1" >
            <CardActionArea>
            <CardMedia
                className='p1image'
                component="img"
                image= {projectonecard}
                alt="Stem salary database project card"
                
            />
            
            <CardContent sx={{backgroundColor: 'seaGreen'}}>
                <Typography gutterBottom variant="h5" component="div">
                STEM SALARIES VISUALIZATIONS
                </Typography>
                <Divider variant="left" color="white"/>
                <Typography variant="body2" color="text.secondary">
                Turned a csv dataset from Kaggle into a database. Used the created database to create a website for that database.The web app allows users to visualize different aspects of salaries through
                visuals. The web app also allows users to search salaries of different criterias
                </Typography>
            </CardContent>

            </CardActionArea>
            <CardActions>
            <Button size="small" color="primary">
            

            <a href="https://davis2020-streamlit-heroku-streamapp-oq0llk.streamlitapp.com/?utm_medium=email" target="_blank"><Box
          sx={{
            color: 'success.dark',
            display: 'inline',
            fontWeight: 'bold',
            mx: 0.5,
            fontSize: 14,
          }}
          >WEB APP</Box></a>

        

<a href="https://github.com/Davis2020/streamlit_heroku" target="_blank"><Box
          sx={{
            color: 'success.dark',
            display: 'inline',
            fontWeight: 'bold',
            mx: 0.5,
            fontSize: 14,
          }}
          >GITHUB</Box></a>

                
            </Button>
            </CardActions>
            
            <CardActions sx={{width: "100%"}} className="cardaction1">
                <Stack direction="column" spacing={1}>
                    <Chip color="primary" label="DATABASE" />
                    <Chip color="primary" label="DATA ANALYSIS" />
                    
                </Stack>
                <Stack direction = "column" spacing={1}>
                    <Chip color="secondary" label="PYTHON" />
                    <Chip color="secondary" label="SQL" />
                </Stack>
            </CardActions>
            
        </Card>

        <Card className="card2">
            <CardActionArea>
            <CardMedia
                className='p1image'
                component="img"
                image={projecttwocard}
                alt="Credit evaluation model project card"
               
            />
            <CardContent sx={{backgroundColor: 'seaGreen'}}>
                <Typography gutterBottom variant="h5" component="div">
                CREDIT LOAN RISK EVALUATION
                </Typography>
                <Divider variant="left" color="white" />
                <Typography variant="body2" color="text.secondary">
                This project is about assessing whether an applicant should be granted loan or not using binary logistic regression.
                </Typography>
            </CardContent>
            </CardActionArea>
            <CardActions>
            <Button size="small" color="primary">
            <Button size="small" color="primary">
            

            <a href="https://seescoto-cds303-model-app-st-app-eifm6y.streamlitapp.com/" target="_blank"><Box
          sx={{
            color: 'success.dark',
            display: 'inline',
            fontWeight: 'bold',
            mx: 0.5,
            fontSize: 14,
          }}
          >WEB APP</Box></a>

<a href="https://github.com/seescoto/cds303_model_app" target="_blank"><Box
          sx={{
            color: 'success.dark',
            display: 'inline',
            fontWeight: 'bold',
            mx: 0.5,
            fontSize: 14,
          }}
          >GITHUB</Box></a>


                
            </Button>
            </Button>
            </CardActions>

            <CardActions>
                <Stack direction="column" spacing={0.5}>
                    <Chip color="primary" label="DATA ANALYSIS" />
                    <Chip color="secondary" label="R" />
                </Stack>
                <Stack direction="column" spacing={0.5}>
                    <Chip color="primary" label="DATA MODELLING" />
                    <Chip color="secondary" label="PYTHON" />
                </Stack>
            </CardActions>

            
        </Card>

        <Card className="card3">
            <CardActionArea>
            <CardMedia
                className='p1image'
                component="img"
                image= {projectthreecard}
                alt="Project three card"
                
            />
            <CardContent sx={{backgroundColor: 'seaGreen'}}>
                <Typography gutterBottom variant="h5" component="div">
                Football "Soccer" Analysis (Project coming soon)
                </Typography>
                <Divider variant="left" color="white"/>
                <Typography variant="body2" color="text.secondary">
                Simplifying over analysis on the beautiful game. When completed
                , this project will produce a website which will analyze every 
                group in football such as players, managers, owners, teams, leagues 
                and continents. This project is currently in production.
                </Typography>
            </CardContent>
            </CardActionArea>
            <CardActions>
            </CardActions>
        </Card>

        <Card className="card4">
            <CardActionArea>
            <CardMedia
                className='p1image'
                component="img"
                image={comingsoonprojectcard}
                alt="coming soon project card"
                
            />
            <CardContent sx={{backgroundColor: 'seaGreen'}}>
                <Typography gutterBottom variant="h5" component="div">
                Project coming soon
                </Typography>
                <Divider variant="left" color="white"/>
                <Typography variant="body2" color="text.secondary">
                Project card will be updated soon
                </Typography>
            </CardContent>
            </CardActionArea>
            <CardActions>
            
            </CardActions>
        </Card>
      </div>
    );
  };



  export default Projects;